import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import { useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');

function Physical (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);

    const [Age, setAge]= useState(localStorage.getItem("Age"))
    const prevLocation = {
        pathname: '../job',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }
    const next = () =>{
        let nextLocation = {}

            nextLocation = {
                pathname: '../intervention',
                state: { d: d }
            }

        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const [stored, setStored] =  useState("")
    const [JobStudent, setJobStudent]= useState({})


    // set control value and name to classic inputs using the custom Hook useInput
    const {value: Field57DeathOtherDetail, bind: bindField57DeathOtherDetail, reset: setField57DeathOtherDetail } = useInput('');
    const {value: Field5302HostipalEndDate, bind: bindField5302HostipalEndDate, reset: setField5302HostipalEndDate } = useInput('');
    const {value: Field5301HostipalBeginDate, bind: bindField5301HostipalBeginDate, reset: setField5301HostipalBeginDate } = useInput('');
    const {value: Field53HospitalizedDoctorname, bind: bindField53HospitalizedDoctorname, reset: setField53HospitalizedDoctorname } = useInput('');

    const {value: Field58DeathDate, bind: bindField58DeathDate, reset: setField58DeathDate} = useInput('')

    // radio input custom handleChange
    const [Field57Death, setField57Death] = useState("");
    const handleChangeField57Death = (e) => {
        let value = e.target.value
        setField57Death(value);
    }
    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const JobStudent = JSON.parse(localStorage.getItem('jobStudent'))

            if (JobStudent){
                setJobStudent(true)
            }

            const physical = JSON.parse(localStorage.getItem('physical'))

            if (physical){
                setStored(true)
                setField57DeathOtherDetail(physical.Field57DeathOtherDetail)
                setField5302HostipalEndDate(physical.Field5302HostipalEndDate)
                setField5301HostipalBeginDate(physical.Field5301HostipalBeginDate)
                setField53HospitalizedDoctorname(physical.Field53HospitalizedDoctorname)
                setField58DeathDate(physical.Field58DeathDate)
                setField57Death(physical.Field57Death)
            }
        };
        fetchData()
    }, []);

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = Field57Death === "" ||
            (Field57Death === "deathHospital" && Field5302HostipalEndDate === "" && Field5301HostipalBeginDate === "" && Field53HospitalizedDoctorname === "") ||
            (Field57Death === "other" && Field57DeathOtherDetail === "" && Field58DeathDate === "")

        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let physical = {
                Field57DeathOtherDetail:Field57DeathOtherDetail,
                Field5302HostipalEndDate:Field5302HostipalEndDate,
                Field5301HostipalBeginDate:Field5301HostipalBeginDate,
                Field53HospitalizedDoctorname:Field53HospitalizedDoctorname,
                Field58DeathDate:Field58DeathDate,
                Field57Death:Field57Death,
            }
            //let stringInfo = JSON.stringify(physical)
            let stringInfo = serialize(physical, {isJSON: true});
            localStorage.setItem("physical" , stringInfo)
            next()
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={5}/>:<BreadCrumb n={6}/>}
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("CONSEQUENCESTITLE"): i18n.t("CONSEQUENCESTITLE") }</h3>
                            <h4 className={"text-primary"}>{ d? i18n.t("Les conséquences corporelles"): i18n.t("Les conséquences corporelles") }</h4>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup check>
                                        <Label for="Field57Death" className={(NotValid && Field57Death === "") ? "text-danger" : "text"}>{ d? i18n.t('Votre proche est décédé(e)') :  i18n.t('Vous avez été blessé')  }:  <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field57Death"  value="locationAccident"  onChange={handleChangeField57Death} checked={Field57Death === "locationAccident"} />
                                                {  i18n.t('field57DeathLocationAccident') }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field57Death" value="wayHospital"  onChange={handleChangeField57Death} checked={Field57Death === "wayHospital"} />
                                                {  i18n.t('field57DeathWayHospital') }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field57Death" value="deathHospital"  onChange={handleChangeField57Death} checked={Field57Death === "deathHospital"} />
                                                {  i18n.t('field57DeathHospital') }
                                            </Label>
                                        </div>
                                        {Field57Death === "deathHospital" &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <h4>{i18n.t("Durée de l'hospitalisation")} <span className={"text-danger"}>*</span></h4>
                                                <Label>{i18n.t("Nom du médecin traitant et/ou de la clinique")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindField53HospitalizedDoctorname}
                                                       placeholder={i18n.t("Entrer le nom du médecin traitant et/ou de la clinique")}
                                                       invalid={(NotValid && Field53HospitalizedDoctorname === "true") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field5301HostipalBeginDate")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="date" {...bindField5301HostipalBeginDate}
                                                       invalid={(NotValid && Field5301HostipalBeginDate === "true") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field5302HostipalEndDate")} <span className={"text-danger"}>*</span></Label>

                                                <Input type="date" {...bindField5302HostipalEndDate}
                                                       invalid={(NotValid && Field5302HostipalEndDate === "true") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                        </div>}
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field57Death" value="other"  onChange={handleChangeField57Death} checked={Field57Death === "other"} />
                                                {  i18n.t('field57DeathOther') }
                                            </Label>
                                        </div>
                                        {Field57Death === "other" &&
                                            <div>
                                        <FormGroup className={"formlevel02"}>
                                            <Label for="Field57DeathOtherDetail">{  i18n.t('field57DeathOtherDetail') } <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className="form-control" {...bindField57DeathOtherDetail} placeholder={i18n.t('placeholderField57DeathOther') } invalid={(NotValid && Field57DeathOtherDetail === "") ? true : undefined}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                                <FormGroup>
                                                    <Label for="Field58DeathDate">{d? i18n.t("field58DeathDate") : i18n.t("field58DeathDate")}</Label>
                                                    <Input type="date" {...bindField58DeathDate} />
                                                    <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </FormGroup>
                                            </div>
                                        }
                                    </FormGroup>
                                   


                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }</button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }</button>
                                    </div>
                                    }
                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Physical

